import { Box } from "@mui/material";
import AdminContactsPanel from "@/components/admin/contacts/AdminContactsPanel";

/**
 * GFG Admin → Contacts (DIV-7808). Reached from the sidebar's GFG-only "Contacts" entry
 * (`Drawer.tsx`, path `/contacts`). Every behaviour lives in `AdminContactsPanel`; this page is
 * only the standard page frame around it.
 */
export default function AdminContacts() {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, fontFamily: "var(--font-lato)" }}>
      <AdminContactsPanel />
    </Box>
  );
}
